import { css } from 'emotion';

export const drawer = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;

export const placeholder = css`
  width: 40%;
  display: flex;
  flex-direction: column;
  margin-top: 10px !important;
  margin-bottom: 5px !important;

  & > svg {
    width: 100%;
    height: 100%;
  }
`;

export const description = css`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
